import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { ParamsUsed as ParamsType } from '../../../types/store/markettingContentGeneration/majorProcessActions';

export const contentParamsSegment = stateSegmentWithReset<ParamsType>({
  // options
  currentAvailableActionOptions: [],
  currentAvailableBrandOptions: [],
  currentAvailableCountryOptions: [],
  currentAvailableIndicationOptions: [],
  currentAvailableAudienceOptions: [],
  currentAvailableContentTypeOptions: [],
  currentAvailableSegmentOptions: [],
  currentAvailableSectionOptions: [],
  currentAvailableToneOptions: [],
  currentAvailablePlatformOptions: [],
  currentAvailableTopicOptions: [],
  currentAvailableContentStyleOptions: [],
  currentAvailableDestinationFormatOptions: [],
  currentAvailableLanguageOptions: [],
  currentAvailableToneLevelOptions: [],

  // selections
  currentSelectedBrand: '',
  currentSelectedCountry: '',
  currentSelectedIndication: '',
  currentSelectedAudience: '',
  currentSelectedContentType: '',
  currentSelectedSegment: '',
  currentSelectedPlatform: '',
  currentSelectedSections: [],
  currentSelectedTone: '',
  currentSelectedTopic: [],
  currentSelectedContentStyle: '',
  currentSelectedExclusion: [],
  currentSelectedModules: '',
  currentSelectedInclusion: [],
  currentSelectedDaring: false,
  currentSelectedCompassionate: false,
  currentSelectedAction: '',
  currentSelectedDestinationFormat: '',
  currentSelectedFile: [],
  currentSelectedLanguage: '',
  currentContextValue: '',
  currentSelectedUnbrandedFlag: false,
  currentSelectedToneLevel: '',
  currentSelectedApplicableRecommendation: [],
  currentSelectedExtendedLibraryFlag: false,
});
contentParamsSegment.debugLabel = 'contentParamsSegment';
